export const supportedLanguages = {
  english: "English",
  italian: "Italiano",
  spanish: "Castellano",
  russian: "Русский",
  serbian: "сербский",
  bulgarian: "Български",
};
